module.exports = __webpack_public_path__ + "img/beefeater-age-confirm-img-mobile.47670290.png";